import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class IsVisibleOnGridWithSettingsBaseValueConverter {
    toView(array, settings) {
        let tempArray = new Array<Object>();

        for(let index in array) {
            let value = array[index];
            
            let itemIndex = settings.map(function (item) { return item.ColumnName; }).indexOf(value['ColumnName']);

            if(itemIndex >= 0) {
                tempArray[itemIndex] = value;
            }
        }

        return tempArray;
    }
}